import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.bqn = bracketIndenting({ line: "#" })
